import * as messages from "../../../constants/ToastrConstants";
import { showToastrSuccess, showToastrError, showToastrWarning } from "../../../util/toastr.js";
import assign from 'object-assign';
import publicatieApi from "../../../api/e-loket/publicatieApi";
import { ValidationMessageTypes } from "../../../constants/ComponentConstants";
import { Landen } from "../../../constants/DomainConstants";

export default class PublicatiePageHelper {

	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;

		const params = context.props.match.params;
		const modelId = params.modelId;
		const disabled = params.isDisabled || false;

		const returnUrl = decodeURIComponent(context.props.match.params.returnUrl);

		if (modelId) {
			ajaxActions.started();
			publicatieApi.get(modelId).then((response) => {
				ajaxActions.ended();
				this.processModel(response);
			})
				.catch((ex) => {
					ajaxActions.failed();
					context.props.throwException(ex);
				});
		}

		context.setState({
			modelId,
			returnUrl,
			disabled
		});
	}

	save() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;

		let errors = null;
		let model = null;

		let modelToSave = this.context.state.model;

		ajaxActions.started();
		return publicatieApi.save(modelToSave).then((response) => {
			ajaxActions.ended();

			if (response.statusText === "OK" && !response.data.hasValidationErrors) {
				if (Object.keys(response.data.validationResults).length !== 0) {
					model = assign({}, response.data.item);
					errors = assign({}, response.data.validationResults);
					showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS_SAVED, true);
				}
				else {
					model = assign({}, response.data.item, {});
					errors = {};
				}
				context.setState({
					hasUnsavedChanges: false,
					scrollToTop: true
				});

				showToastrSuccess(messages.MESSAGE_SAVED, true);
			} else {
				errors = assign({}, response.data.validationResults);
				model = assign({}, response.data.item, {});
				showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
			}

			context.props.validatieStatussenLoaded(response.data.item.validatiestatusses);

			this.context.setState({
				errors,
				validationMessageType: response.data.hasValidationErrors ? ValidationMessageTypes.ERROR : ValidationMessageTypes.WARNING,
				model,
				shouldScrollToFirstError: true
			});
		})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	changeRadio(event) {
		const value = event.target.value === "true" ? true : false;
		const property = event.target.name;

		const model = this.context.state.model;
		model[property] = value;

		this.context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	processModel(response) {
		const context = this.context;
		let model = response.data;
		let tochtId = model.id;
		context.props.validatieStatussenLoaded(model.validatiestatusses);

		context.setState({
			model,
			tochtId
		});

		context.props.loadLayout(model.naam, tochtId, model.validatiestatusses, null, model.svlDossierId);
	}

	getErrorForProperty(propertyName) {
		const errors = this.context.state.errors;

		return errors && errors ? errors[propertyName] : null;
	}

	changeSubcomponent(event) {
		const model = this.context.state.model;
		this.change(event);

		switch (event.target.name) {
			case "kleedkamersStart":
				{
					model.kleedkamersManVrouwStart = null;
					break;
				}
			case "kleedkamersAankomst":
				{
					model.kleedkamersManVrouwAankomst = null;
					break;
				}
			case "douches":
				{
					model.douchesManVrouw = null;
					break;
				}
			case "aandenken":
				{
					model.aandenkenOmschrijving = null;
					break;
				}
			case "kleedkamersManVrouwStart":
				{
					if (event.target.value === false || event.target.value === "false")
						this.context.setState({
							showVoorzieningenPopup: true
						});
					break;
				}
			case "kleedkamersManVrouwAankomst":
				{
					if (event.target.value === false || event.target.value === "false")
						this.context.setState({
							showVoorzieningenPopup: true
						});
					break;
				}
			case "douchesManVrouw":
				{
					if (event.target.value === false || event.target.value === "false")
						this.context.setState({
							showVoorzieningenPopup: true
						});
					break;
				}
			default:
				break;
		}
		this.context.setState({ model });
	}

	confirmVoorzieningenPopup() {
		this.context.setState({
			showVoorzieningenPopup: false
		});
	}

	change(event, mask) {
		let value = event.target.value;
		const property = event.target.name;

		const model = this.context.state.model;

		if (mask) {
			if (mask.indexOf("https") > -1) {
				value = value.replace("http://", "https://");
			}
			else {
				value = value.replace("https://", "http://");
			}

			if ((value.split(mask).length - 1) > 1) {
				value = value.replace(mask, "");
			}

			if ((mask === value)) {
				model[property] = "";
			}
			else {
				model[property] = value;
			}
		}
		else {
			model[property] = value;
		}

		if (model.aankomstLand == Landen.BELGIE) {
			model.aankomstplaatsGemeenteBuitenland = null;
		}
		else {
			model.aankomstGemeente = null;
		}

		this.context.setState({
			model,
			hasUnsavedChanges: true
		});
	}
}
